module.exports = __webpack_public_path__ + "67fa8064ee5c9f8796ca985f089106d8.mp4";